import "../Common/css/styles.css";
import welcomeImg from "../Assets/Images/graduate.png";
import { Box, Divider, Grid, Modal } from "@mui/material";
import { Campaign } from "@mui/icons-material";
import React, { useEffect, useState } from "react";
import { getNotices } from "src/Services/notice_api";
import trophy from "../Assets/Images/success.png";
import callender from "../Assets/Images/available.png";
import house1 from "../Assets/Images/gale.png";
import house2 from "../Assets/Images/wave.png";
import house3 from "../Assets/Images/stone.png";
import house4 from "../Assets/Images/blaze.png";
import { getInstitutionUpdates } from "src/Services/admin_api";
import { PieChart, Pie, Cell, Legend, Tooltip } from "recharts";
import { getAttendanceRecords } from "src/Services/attendance_api";
import { useNavigate } from "react-router-dom";

export default function Dashboard() {

  const username = sessionStorage.getItem("username") || "";
  const token = sessionStorage.getItem("token") || "";
  const house = sessionStorage.getItem("house") || "N/A";

  const [notices, setNotices] = React.useState<any[]>([]);
  const [institutionUpdates, setInstitutionUpdates] = React.useState<any[]>([]);
  const [openNotice, setOpenNotice] = React.useState(false);
  const [selectedNotice, setSelectedNotice] = React.useState<any>(null);
  const [openAllNotices, setOpenAllNotices] = React.useState(false);
  const [selectedFullNotice, setSelectedFullNotice] = React.useState<any>(null);
  const [image, setImage] = React.useState<string>(house1);
  const [otherHouses, setOtherHouses] = React.useState<string[]>([]);
  const [activeSlide, setActiveSlide] = React.useState(0);
  const [record, setRecord] = useState<any>("");
  const userId = sessionStorage.getItem("userId") || "";

  const navigate = useNavigate();

  const handleGetAttendanceRecords = async () => {
    try {
      const res = await getAttendanceRecords(token, userId);
      setRecord(res);      
    } catch (error) {
      setRecord("");
    }
  };

  useEffect(() => {
    handleGetAttendanceRecords();
  }, []);

  const attendanceData = [
    { name: "Present", value: record.attendancePercentage !== null ? record.attendancePercentage : 0 },
    { name: "Absent", value: record.attendancePercentage !== null ? 100 - record.attendancePercentage : 100 },
  ];

  const spg = sessionStorage.getItem("spg") || "0.0";
  const badge = sessionStorage.getItem("badge") || "No Badge";

  const COLORS = ["#c0bd11ff", "#d3d3d3"];

  const handleOpenAllNotices = () => {
    setOpenAllNotices(true);
    setSelectedFullNotice(notices[0]); // auto-select first notice
  };

  const handleCloseAllNotices = () => {
    setOpenAllNotices(false);
    setSelectedFullNotice(null);
  };

  const carouselRef = React.useRef<HTMLDivElement>(null);

  useEffect(() => {
    const interval = setInterval(() => {
      if (carouselRef.current && institutionUpdates.length > 0) {
        const firstChild = carouselRef.current.children[0];
        if (firstChild) {
          const width = (firstChild as HTMLElement).offsetWidth + 15; // 15px gap
          carouselRef.current.scrollBy({ left: width, behavior: "smooth" });

          // Update active slide index
          setActiveSlide((prev) => (prev + 1) % institutionUpdates.length);

          // Move first child to end for infinite loop
          setTimeout(() => {
            if (carouselRef.current) {
              carouselRef.current.appendChild(firstChild);
              carouselRef.current.scrollLeft -= width;
            }
          }, 500);
        }
      }
    }, 3000);

    return () => clearInterval(interval);
  }, [institutionUpdates]);

  const handleOpenNotice = (notice: any) => {
    setSelectedNotice(notice);
    setOpenNotice(true);
  };

  const handleCloseNotice = () => {
    setOpenNotice(false);
    setSelectedNotice(null);
  };

  const handleGetNotices = async () => {
    try {
      const res = await getNotices(token);
      setNotices(res);
    } catch (error) {
      setNotices([]);
    }
  }

  const handleGetInstitutionUpdates = async () => {
    try {
      const res = await getInstitutionUpdates(token);
      setInstitutionUpdates(res);
    } catch (error) {
      setInstitutionUpdates([]);
    }
  }

  useEffect(() => {

    if (house === "GALE") {
      setImage(house1);
      setOtherHouses([house2, house3, house4]);
    } else if (house === "WAVE") {
      setImage(house2);
      setOtherHouses([house1, house3, house4]);
    } else if (house === "STONE") {
      setImage(house3);
      setOtherHouses([house1, house2, house4]);
    } else if (house === "BLAZE") {
      setImage(house4);
      setOtherHouses([house1, house2, house3]);
    }

    handleGetNotices();
    handleGetInstitutionUpdates();
  }, []);

  return (
    <div className="comman-outer">
      <div className="welcome-card">
        <div className="welcome-text">
          <h2>Hello <span>{username},</span></h2>
          <p>welcome to Vanguard Academy</p>
        </div>

        <div className="welcome-image">
          <img src={welcomeImg} alt="welcome" />
        </div>
      </div>
      <Grid container spacing={2} style={{ marginTop: "20px" }}>
        <Grid item xs={12} md={6}>
          {/* Notice Board */}
          <div className="notice-board">
            <div className="notice-header">
              <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                <h3>Notice Board</h3>
                <span className="notice-icon">
                  <Campaign style={{ color: "#a18102", fontSize: "26px" }} />
                </span>
              </div>


              <div className="notice-right">

                <button className="see-all-btn" onClick={handleOpenAllNotices}>See All</button>
              </div>
            </div>


            <div className="notice-list">
              {notices.length > 0 ? (
                notices.slice(0, 3).map((item) => (
                  <div className="notice-item" key={item.id} onClick={() => handleOpenNotice(item)}>
                    <h4 className="notice-title">
                      {item.noticeTitle || "Untitled Notice"}
                    </h4>

                    <p className="notice-description">
                      {item.noticeMessage.length > 50 ? item.noticeMessage.slice(0, 50) + "..." : item.noticeMessage || "No description available."}
                    </p>

                    <Divider style={{ backgroundColor: "#555", margin: "10px 0" }} />

                    <span className="notice-created-by">
                      {item.createdAt.split("T")[0]} - {item.userType === 2 ? item.userName : "Admin"}
                    </span>
                  </div>
                ))
              ) : (
                <p style={{ color: "#888", fontSize: "14px" }}>No notices found</p>
              )}
            </div>

          </div>

        </Grid>
        <Grid item xs={12} md={6}>
          <Grid container spacing={2} >
            <Grid item xs={12} md={6}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={12}>
                  <div className="spg-outer">
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                      <img className="spg-image" src={trophy} alt="Success Trophy" />
                      <div className="spg-text">
                        My SPG
                      </div>
                    </div>

                    <div className="spg-value">
                      {spg}
                    </div>
                  </div>
                </Grid>
                <Grid item xs={12} md={12}>
                  <div className="atd-outer" style={{cursor: "pointer"}} onClick={() => navigate("/attendance")}>
                    <div style={{ display: "flex", flexDirection: "column", gap: "10px", justifyContent: "center", alignItems: "center" }}>
                      <PieChart width={150} height={150}>
                        <Pie
                          data={attendanceData}
                          cx="50%"
                          cy="50%"
                          innerRadius={35}
                          outerRadius={75}
                          fill="#8884d8"
                          paddingAngle={2}
                          dataKey="value"
                        >
                          {attendanceData.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                          ))}
                        </Pie>
                        <Tooltip formatter={(value: number) => `${value}%`} />
                      </PieChart>
                      <p style={{ textAlign: "center", marginTop: "5px", fontWeight: "bold" }}>
                        Attendance: {record.attendancePercentage !== null ? record.attendancePercentage : 0}%
                      </p>
                    </div>
                  </div>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} md={6}>
              <div className="house-outer">
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                  <span>You are in House</span>
                  <div>
                    <h3 className="house-name">{house}</h3>
                  </div>
                </div>

                <Divider style={{ backgroundColor: "#a09c9ca4", margin: "5px 0", width: "90%" }} />

                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "#393838ff", padding: "10px", borderRadius: "10px" }}>
                  <img className="house-image" src={image} alt="" />
                </div>
                <Divider style={{ backgroundColor: "#a09c9ca4", margin: "5px 0", width: "90%" }} />

                <div className="other-houses-outer">
                  <div className="other-houses-images">
                    {otherHouses.map((houseImg, index) => (
                      <img key={index} className="other-house-image" src={houseImg} alt={`House ${index + 1}`} />
                    ))}
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      {/* Institution Updates */}

      <Divider style={{ backgroundColor: "#555", margin: "30px 0" }} />

      <div className="institution-updates-header">
        <h3>Institution Updates</h3>
      </div>

      <Grid container spacing={2} style={{ marginTop: "20px" }}>
        <Grid item xs={12}>
          <div className="institution-updates-carousel" ref={carouselRef}>
            {institutionUpdates.length > 0 ? (
              institutionUpdates.map((update) => (
                <div key={update.id} className="update-card">
                  <h4 className="update-title">{update.noticeTitle || "Untitled Update"}</h4>
                  <p className="update-description">
                    {update.noticeMessage}
                  </p>

                  <Divider style={{ backgroundColor: "#555", margin: "10px 0" }} />

                  <span className="update-date">{update.createdAt.split("T")[0]}</span>
                </div>
              ))
            ) : (
              <p style={{ color: "#888", fontSize: "14px" }}>No updates found</p>
            )}
          </div>
          <div style={{ textAlign: "center", marginTop: "10px" }}>
            {institutionUpdates.map((_, index) => (
              <span
                key={index}
                style={{
                  display: "inline-block",
                  width: activeSlide === index ? "12px" : "8px",
                  height: activeSlide === index ? "12px" : "8px",
                  margin: "0 5px",
                  borderRadius: "50%",
                  backgroundColor: activeSlide === index ? "#c0bd11ff" : "#888",
                  transition: "all 0.3s",
                }}
              />
            ))}
          </div>

        </Grid>
      </Grid>

      <Modal open={openNotice} onClose={handleCloseNotice}>
        <Box className="notice-modal-container">
          {selectedNotice && (
            <>
              <h2 className="notice-modal-title">{selectedNotice.noticeTitle}</h2>

              <Divider style={{ backgroundColor: "#555", margin: "10px 0" }} />

              <p className="notice-modal-description">
                {selectedNotice.noticeMessage}
              </p>

              <Divider style={{ backgroundColor: "#555", margin: "10px 0" }} />

              <div className="notice-modal-footer">
                <span>
                  Posted By:{" "}
                  {selectedNotice.userType === 2
                    ? selectedNotice.userName
                    : "Admin"}
                </span>

                <span>
                  {selectedNotice.createdAt.split("T")[0]}
                </span>
              </div>

              <button className="notice-modal-close-btn" onClick={handleCloseNotice}>
                Close
              </button>
            </>
          )}
        </Box>
      </Modal>

      {/* FULL SCREEN NOTICE BOARD MODAL */}
      <Modal open={openAllNotices} onClose={handleCloseAllNotices}>
        <Box className="full-notice-modal">
          {/* HEADER */}
          <div className="full-notice-header">
            <h2>All Notices</h2>
            <button className="full-notice-close-btn" onClick={handleCloseAllNotices}>
              ✕
            </button>
          </div>

          <div className="full-notice-body">

            {/* LEFT PANE: NOTICE LIST */}
            <div className="full-notice-list">
              {notices.length > 0 ? (
                notices.map((n) => (
                  <div
                    key={n.id}
                    className={`full-notice-list-item ${selectedFullNotice?.id === n.id ? "active" : ""
                      }`}
                    onClick={() => setSelectedFullNotice(n)}
                  >
                    <h4>{n.noticeTitle}</h4>
                    <p>
                      {n.noticeMessage.length > 60
                        ? n.noticeMessage.slice(0, 60) + "..."
                        : n.noticeMessage}
                    </p>
                    <span className="notice-date-small">
                      {n.createdAt.split("T")[0]}
                    </span>
                  </div>
                ))
              ) : (
                <p className="no-notice-text">No notices available</p>
              )}
            </div>

            {/* RIGHT PANE: NOTICE PREVIEW */}
            <div className="full-notice-preview">
              {selectedFullNotice ? (
                <>
                  <h2 className="preview-title">{selectedFullNotice.noticeTitle}</h2>
                  <Divider style={{ backgroundColor: "#444", margin: "10px 0" }} />

                  <p className="preview-description">
                    {selectedFullNotice.noticeMessage}
                  </p>

                  <Divider style={{ backgroundColor: "#444", margin: "10px 0" }} />

                  <p className="preview-footer">
                    Posted By:{" "}
                    {selectedFullNotice.userType === 2
                      ? selectedFullNotice.userName
                      : "Admin"}
                    <br />
                    Date: {selectedFullNotice.createdAt.split("T")[0]}
                  </p>
                </>
              ) : (
                <p className="preview-placeholder">Select a notice to preview</p>
              )}
            </div>
          </div>
        </Box>
      </Modal>


    </div>
  );
}
